var ga = ga || {};
( function () {
    'use strict';
    espresso.util.analytics = {};
    espresso.util.analytics.init = function () {
        espresso.util.analytics.trackTrans();
        espresso.util.analytics.trackEvents();
        espresso.util.analytics.bindTrackingEvents();
    };
    espresso.util.analytics.trackTrans = function () {
        var jGoogleAnalyticsEcommerceAddTransaction = jQuery( '.js-e-google-analytics-ecommerce-addTransaction' );
        if ( jGoogleAnalyticsEcommerceAddTransaction.length === 1 ) {
            try {
                eval( jGoogleAnalyticsEcommerceAddTransaction.text().replace( /\s/g, ' ' ) );
            }
            catch ( error ) {
                //console.log(error);
                //console.log( jGoogleAnalyticsEcommerceAddTransaction.text().replace( /\s/g, ' ' ) );
            }
        }
    };
    espresso.util.analytics.trackEvents = function () {
        jQuery( '.analytics-trackEvent-data' ).each( function () {
            try {
                eval( jQuery( this ).text() );
            }
            catch ( error ) {
                //console.log(error);
                //console.log( jQuery(this).text() );
            }
        } );
    };
    espresso.util.analytics.bindTrackingEvents = function () {
        var filetypes = /\.(zip|exe|dmg|pdf|doc.*|xls.*|ppt.*|rar|mov|avi|flv)$/i,
            imagetypes = /\.(jpg|png|gif)$/i;
        jQuery( 'body' ).on( 'click', 'a', function () {
            var jThis = jQuery( this ),
                trackEvent = true,
                href = ( typeof ( jThis.attr( 'href' ) ) !== 'undefined' ) ? jThis.attr( 'href' ) : '',
                internalLink = href.match( document.domain.split( '.' ).reverse()[ 1 ] + '.' + document.domain.split( '.' ).reverse()[ 0 ] ),
                fileExtension = ( /[.]/.exec( href ) ) ? /[^.]+$/.exec( href ) : undefined;
            if ( !href.match( /^javascript:/i ) ) {
                var eventObject = {};
                eventObject.value = 0;
                if ( href.match( /^mailto\:/i ) ) {
                    eventObject.category = 'email';
                    eventObject.action = 'mailto';
                    eventObject.label = href.replace( /^mailto\:/i, '' );
                }
                else if ( href.match( filetypes ) ) {
                    if ( href.indexOf( 'DWSDownload.aspx?File=' ) !== -1 ) {
                        eventObject.category = 'intended download';
                    }
                    else {
                        eventObject.category = 'involuntary download';
                    }
                    eventObject.action = 'download ' + fileExtension[ 0 ];
                    eventObject.label = href.replace( / /g, '-' );
                }
                else if ( href.match( imagetypes ) && href.indexOf( 'DWSDownload.aspx?File=' ) !== -1 ) {
                    eventObject.action = 'download ' + fileExtension[ 0 ];
                    eventObject.label = href.replace( / /g, '-' );
                    eventObject.category = 'image download';
                }
                else if ( href.match( /^https?\:/i ) && !internalLink ) {
                    eventObject.category = 'external';
                    eventObject.action = 'click';
                    eventObject.label = href.replace( /^https?\:\/\//i, '' );
                }
                else {
                    trackEvent = false;
                }
                if ( trackEvent ) {
                    ga( 'send', 'event', eventObject.category.toLowerCase(), eventObject.action.toLowerCase(), eventObject.label.toLowerCase(), eventObject.value, {
                        useBeacon: true
                    } );
                }
            }
        } );
    };
}() );
